import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import type { TaxabilityCategories } from '@/lib/parts-financial/calculator';

export interface ShopTaxRules {
  id: string;
  shop_id: string;
  categories: TaxabilityCategories;
}

const DEFAULT_CATEGORIES: TaxabilityCategories = {
  parts: true,
  labor: false,
  tires: true,
  shop_supplies: true,
  disposal: false,
  hazmat: false,
  core: true,
  sublet: false,
};

export function useShopTaxRules(shopId: string | null | undefined) {
  return useQuery({
    queryKey: ['shop_tax_rules', shopId],
    enabled: !!shopId,
    queryFn: async (): Promise<ShopTaxRules> => {
      const { data, error } = await supabase
        .from('shop_tax_rules' as any)
        .select('*')
        .eq('shop_id', shopId!)
        .maybeSingle();
      if (error) throw error;
      if (!data) {
        return { id: '', shop_id: shopId!, categories: DEFAULT_CATEGORIES };
      }
      const row = data as unknown as { id: string; shop_id: string; categories: Partial<TaxabilityCategories> };
      return {
        id: row.id,
        shop_id: row.shop_id,
        categories: { ...DEFAULT_CATEGORIES, ...(row.categories || {}) },
      };
    },
  });
}
